<template>
	<form v-if="isWrite" class="q_write" autocomplete="off" @submit.prevent>
		<div class="d_flex input_area">
			<div class="input_box">
				<label class="label_text">{{ $t('input.label.email') }}</label>
				<input
					type="email"
					:placeholder="$t('input.placeholder.email')"
					class=""
					v-model="emailAddress"
				/>
			</div>
			<div class="input_box">
				<label class="label_text">{{ $t('input.label.password') }}</label>
				<input
					type="password"
					:placeholder="$t('input.placeholder.password')"
					class=""
					v-model="password"
				/>
			</div>
		</div>
		<div class="input_box">
			<label class="label_text">{{ $t('input.label.inquiry_type') }}</label>
			<div class="select_wrap">
				<select class="contact_type" v-model="typeSeq">
					<option value="" selected disabled>
						{{ $t('cs.placeholder.type') }}
					</option>
					<option
						v-for="item in ticketTypeList"
						:key="item.seq"
						:value="item.seq"
					>
						{{ item.title }}
					</option>
				</select>
			</div>
		</div>
		<div class="input_box">
			<label class="label_text">{{ $t('input.label.enter_subject') }}</label>
			<input
				type="text"
				:placeholder="$t('cs.placeholder.title')"
				class=""
				v-model="title"
			/>
		</div>
		<div class="input_box">
			<label class="label_text">{{ $t('input.label.inquiry_content') }}</label>
			<textarea
				class="ask"
				:placeholder="$t('cs.placeholder.content')"
				v-model="content"
			></textarea>
		</div>
		<div class="inquiry_button_area">
			<button class="button_primary mr_10">{{ $t('button.cancel') }}</button>
			<button class="button_bg_blue" @click="registTicket">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</form>
	<div v-else class="inquiry_complete">
		<div class="complete_box">
			<div class="status_icon success"></div>
			<p class="mb_10">
				{{ $t('cs.inquiry.text1') }}<br />
				<span class="">{{ $t('cs.inquiry.text2') }}</span>
				{{ $t('cs.inquiry.text3') }}
			</p>
			<button class="button_bg_blue" @click="$emit('goList')">
				{{ $t('button.inquiry_list') }}
			</button>
		</div>
	</div>
	<!-- <div class="pin_container"> -->
	<!-- 모달시작 -->
	<ModalView
		v-if="pinCodeModal"
		@closeModal="pinCodeModal = false"
		add-class="inquiry tal"
	>
		<div>
			<h3 class="title mb_10 mt_0">{{ $t('cs.ticket.id') }}</h3>
			<div class="pl_20 pr_20 pt_20">
				<p class="ticket_title">
					{{ $t('cs.ticket.text1') }}
				</p>
				<label class="pin_number" for="pin_number">
					<input
						v-model="ticketId"
						id="pin_number"
						type="text"
						readonly
						class="tac" /><span class="copy_icon" @click="copyTicketId"></span
				></label>
				<div class="button_area">
					<button class="button_primary" @click="pinCodeModal = false">
						{{ $t('button.cancel') }}
					</button>
					<button
						class="button_bg_blue"
						@click="(isWrite = false), (pinCodeModal = false)"
					>
						{{ $t('button.confirm') }}
					</button>
				</div>
			</div>
		</div>
	</ModalView>
	<!-- 모달끝 -->
	<!-- </div> -->
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import { createTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';
import useClipboard from 'vue-clipboard3';

export default {
	name: 'Inquiry',
	components: { ModalView },
	emits: ['goList'],
	data() {
		return {
			emailAddress: '',
			password: '',
			parentSeq: '',
			typeSeq: '',
			title: '',
			content: '',
			fieldValues: [],
			ticketTypeList: [],
			ticketId: '',
			pinCodeModal: false,
			isWrite: true,
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticketTypeList = data.filter(item => {
				return item.allow_guest === 'Y';
			});
		},
		async registTicket() {
			const params = {
				parent_seq: this.parentSeq,
				type_seq: this.typeSeq,
				title: this.title,
				content: this.content,
				email_address: this.emailAddress,
				password: this.password,
				field_values: this.fieldValues,
			};
			await createTicket(params)
				.then(result => {
					this.ticketId = result.ticket_id;
					this.pinCodeModal = true;
				})
				.catch(commonError);
		},
		copyTicketId() {
			try {
				useClipboard().toClipboard(this.ticketId);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
	},
};
</script>

<style scoped>
.pin_number {
	position: relative;
	width: 100%;
}
.copy_icon {
	position: absolute;
	display: block;
	top: 50%;
	transform: translateY(-50%);
	right: 15px;
	width: 16px;
	height: 16px;
	background: url('~@/assets/images/icon/copy.png') no-repeat;
	background-size: cover;
	cursor: pointer;
}
.rtr_cs .fc_gray_1 {
	color: #919191;
}
.modal_wrap.inquiry .button_area button {
	width: 100%;
}
</style>
